module.exports = __webpack_public_path__ + "static/media/ChatGPT Image Nov 25, 2025, 11_59_13 PM.a3282dae.png";